<div class="d-flex">
	<div class="h4 mx-4 mt-2 mb-1">{{ category }}</div>
</div>
<p-divider></p-divider>
<div class="d-flex flex-wrap">
	<div class="m-1" *ngFor="let report of reports">
		<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="reportSelectedChange.emit(report)" [pTooltip]="report.description">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', report.icon || 'file-chart-line']" size="lg" class="ms-1 me-2"></fa-icon>
					{{ report.name }}
				</div>
			</ng-template>
		</p-button>
	</div>
</div>
